import { QrCode, CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/Button';

export const PhysicalGift = () => {
  return (
    <section id="presente-fisico" className="py-32 gold-gradient relative overflow-hidden">
      {/* Ícone decorativo de fundo com baixa opacidade */}
      <div className="absolute top-0 right-0 p-20 opacity-10">
        <QrCode className="w-64 h-64 text-white" />
      </div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="bg-white/10 backdrop-blur-xl rounded-[3rem] p-12 md:p-20 border border-white/20 flex flex-col md:flex-row items-center gap-16">
          
          {/* Conteúdo de Texto */}
          <div className="flex-1 space-y-6 text-white">
            <h2 className="text-4xl md:text-5xl font-extrabold leading-tight">
              O presente que você ouve, vê e toca.
            </h2>
            <p className="text-xl text-white/80 leading-relaxed">
              Leve a homenagem para o mundo real. Nosso porta-retrato exclusivo vem com uma foto de alta qualidade e um <strong className="text-white">QR Code dinâmico</strong>. Ao apontar a câmera, a pessoa amada assiste ao Cine-Homenagem instantaneamente.
            </p>
            
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <CheckCircle2 className="text-white" size={20} /> 
                <span>Impressão Premium</span>
              </li>
              <li className="flex items-center gap-3">
                <CheckCircle2 className="text-white" size={20} /> 
                <span>QR Code Eterno</span>
              </li>
              <li className="flex items-center gap-3">
                <CheckCircle2 className="text-white" size={20} /> 
                <span>Entrega em todo o Brasil</span>
              </li>
            </ul>

            {/* Botão Branco para contrastar com o fundo dourado */}
            <button className="px-8 py-4 bg-white text-[#B8860B] rounded-full font-bold shadow-2xl hover:bg-slate-100 transition-all active:scale-95">
              Garantir meu Porta-Retrato
            </button>
          </div>
          
          {/* Visual do Porta-Retrato */}
          <div className="flex-1 w-full max-w-sm">
            <div className="bg-white p-4 rounded-xl shadow-2xl rotate-2 hover:rotate-0 transition-transform duration-500">
              <div className="border-4 border-slate-50 p-2 rounded-lg">
                <img 
                  src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=800" 
                  alt="Porta Retrato Exemplo" 
                  className="w-full aspect-[3/4] object-cover rounded shadow-inner"
                />
                <div className="mt-4 flex justify-between items-center px-2">
                  <div className="w-16 h-16 bg-slate-100 rounded flex items-center justify-center border border-slate-200">
                    <QrCode className="w-10 h-10 text-slate-800" />
                  </div>
                  <div className="text-right">
                    <p className="text-xs font-bold text-slate-400 uppercase">Escaneie o amor</p>
                    <p className="text-sm font-bold text-slate-800">Encant-Me</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};